function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.3487 12.0347C25.5962 12.0347 24.5994 12.018 23.3584 12.018C20.3318 12.018 17.8432 9.51301 17.8432 6.45801V1.09801C17.8432 0.676341 17.5066 0.333008 17.0891 0.333008H8.27336C4.15926 0.333008 0.833984 3.70967 0.833984 7.84801V25.8063C0.833984 30.148 4.31769 33.6663 8.61662 33.6663H21.7444C25.8437 33.6663 29.1673 30.3113 29.1673 26.1697V12.7847C29.1673 12.3613 28.8323 12.0197 28.4132 12.0213C27.7085 12.0263 26.8636 12.0347 26.3487 12.0347Z",
  fill: "#0A4AB7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8078 1.27895C21.3095 0.760616 20.4395 1.11728 20.4395 1.83562V6.23062C20.4395 8.07395 21.9578 9.59062 23.8011 9.59062C24.9628 9.60395 26.5761 9.60728 27.9461 9.60395C28.6478 9.60228 29.0045 8.76395 28.5178 8.25728C26.7595 6.42895 23.6111 3.15228 21.8078 1.27895Z",
  fill: "#0A4AB7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.9568 15.9787H15.5985C16.2835 15.9787 16.8401 15.4237 16.8401 14.7387C16.8401 14.0537 16.2835 13.4971 15.5985 13.4971H9.9568C9.2718 13.4971 8.7168 14.0537 8.7168 14.7387C8.7168 15.4237 9.2718 15.9787 9.9568 15.9787ZM9.9568 24.3023H19.0301C19.7151 24.3023 20.2718 23.7473 20.2718 23.0623C20.2718 22.3773 19.7151 21.8206 19.0301 21.8206H9.9568C9.2718 21.8206 8.7168 22.3773 8.7168 23.0623C8.7168 23.7473 9.2718 24.3023 9.9568 24.3023Z",
  fill: "white"
});

function SvgPaperDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperDefault);
export default __webpack_public_path__ + "static/media/paperDefault.1cb07910e464e9cd6844b02fa26297db.svg";
export { ForwardRef as ReactComponent };